import styled from 'styled-components';

export const SpecialistReviewsContainer = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;

  & > div {
    padding-bottom: 30px;
    padding-top: 30px;
    border-bottom: 1px solid #eeeeee;

    &:first-child {
      padding-top: 0;
    }
  }
`;
